import { createApi } from '@reduxjs/toolkit/query/react';
import {
    ForecastWeatherResponseIF,
    GetForecastRequestIF,
} from '@/api/weatherApi/types';
import { fetchRestApiQuery } from '@/helpers/api';

export const weatherApi = createApi({
    reducerPath: 'weatherApi',
    baseQuery: fetchRestApiQuery('/Weather'),
    endpoints: (builder) => ({
        getForecast: builder.query<
            ForecastWeatherResponseIF,
            GetForecastRequestIF
        >({
            query: ({ cityGuid, forecastDays }) => ({
                url: '/forecast',
                params: {
                    CityGuid: cityGuid,
                    ForecastDays: forecastDays,
                },
            }),
        }),
    }),
});
